import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { FieldErrors, FieldPath, UseFormRegister, UseFormWatch } from 'react-hook-form';

import { getError } from '@/utils/hookFormUtils';

import { CreateOrderFormType } from '../create-order-schema';

interface InputRefProps {
  errors: FieldErrors<CreateOrderFormType>;
  register: UseFormRegister<CreateOrderFormType>;
  name: FieldPath<CreateOrderFormType>;
  watch: UseFormWatch<CreateOrderFormType>;
}

const InputRef = ({ errors, register, name, watch }: InputRefProps) => {
  const fieldValue = watch(name) as string | undefined;
  const error = getError(errors, name);

  return (
    <Grid size={{ xxs: 12 }} sx={{ mt: 2 }}>
      <TextField
        {...register(name)}
        value={fieldValue || ''}
        size="small"
        variant="outlined"
        fullWidth
        label="Referencia"
        placeholder="Ref: N° de interior / Entre calles / Justo a escuela / Frente a parque"
        error={!!error}
        helperText={error?.message ? String(error.message) : undefined}
        slotProps={{
          htmlInput: {
            autoComplete: 'off',
            role: 'presentation',
            'data-form-type': 'other',
            'data-lpignore': 'true',
            'data-1p-ignore': 'true',
          },
        }}
      />
    </Grid>
  );
};

export default InputRef;
